export const SUBMIT_ERROR_USER_EXISTS = "SUBMIT_ERROR_USER_EXISTS";
export const submitFailedUserExists = (email) => ({
  type: SUBMIT_ERROR_USER_EXISTS,
  email,
});

export const DISMISS_ERROR = "DISMISS_ERROR";
